import { useGame } from '../store/game';
import { CHRONICLES, S, theme } from '../theme';
import { AUDIO_CREDITS, MUSIC_CREDIT } from '../audio/credits';

export function About() {
  const go = useGame((s) => s.go);
  return (
    <div className="page" style={{ maxWidth: 760 }}>
      <h1 style={{ fontSize: '2.4rem' }}>Regras em resumo</h1>
      <RulesContent />
      <h2 className="section-title">Sobre</h2>
      <p>{S.disclaimer}</p>
      <h2 className="section-title">Créditos de áudio</h2>
      <p>{MUSIC_CREDIT}</p>
      <p className="muted">Gravações em domínio público (CC0), quando presentes. Os demais efeitos são sintetizados pelo jogo.</p>
      <ul>
        {AUDIO_CREDITS.map((c) => (
          <li key={c.work}>
            <strong>{c.use}:</strong>{' '}
            {c.url ? (
              <a href={c.url} target="_blank" rel="noreferrer">
                {c.work}
              </a>
            ) : (
              c.work
            )}
            {c.author ? `, de ${c.author}` : ', OpenGameArt'} (CC0)
          </li>
        ))}
      </ul>
      <button className="btn" onClick={() => go('home')}>
        Voltar
      </button>
    </div>
  );
}

/** Regras em resumo (tela Sobre e painel "Regras" da partida). */
export function RulesContent() {
  return (
    <>
      <p className="muted">
        De 3 a 6 guildas disputam o continente. Cada uma recebe uma missão secreta: cumpri-la vence na hora. Se ninguém cumprir até o fim da
        rodada 10, acontece o Server Save e vence a maior pontuação.
      </p>
      <h2 className="section-title">Turno</h2>
      <ol>
        <li>
          <strong>Reforços:</strong> o maior entre 3 e metade dos seus territórios, mais o bônus de cada região completa, mais trocas de
          cartas (obrigatória com 5 cartas). Troque 3 iguais ou 3 diferentes; o Mapa Rasgado é curinga (no máximo 2 por troca). Trocas
          valem 4, 6, 8, 10, 12, 15 e depois +5, num contador de toda a mesa.
        </li>
        <li>
          <strong>Ataque:</strong> de um território com 2+ tropas para um vizinho inimigo. O atacante rola até 3 dados (no máximo 2 por
          barco), o defensor até 3. Compare do maior para o menor; empate fica com o defensor.
        </li>
        <li>
          <strong>Remanejar:</strong> mova tropas entre vizinhos seus, deixando 1. Tropa que já se moveu não se move de novo.
        </li>
        <li>
          <strong>Fim:</strong> conquistou algo? Compre 1 carta.
        </li>
      </ol>
      <h2 className="section-title">Vocações</h2>
      <ul>
        {Object.values(theme.vocations).map((v) => (
          <li key={v.id}>
            <strong>{v.name}</strong> ({v.role}): {v.text}
          </li>
        ))}
      </ul>
      <h2 className="section-title">Bosses e loot</h2>
      <p>
        No início de cada rodada, um 5 ou 6 no dado do boss faz um boss surgir no covil de uma região. Quem tem território vizinho ao covil pode
        atacá-lo; só quem dá o <strong>último golpe</strong> leva o loot (escolhe 1 de 2) e conta o boss morto, mas cada 2 de vida que você
        tira de um boss rende 1 carta de território na hora. A primeira guilda a dominar cada região inteira ganha 1 loot. Se o timer zerar, o boss
        faz uma raid. Jogadores eliminados viram mestres dos bosses e escolhem onde eles surgem. Cada jogador guarda no máximo 3 cartas de
        loot.
      </p>
      <ul>
        {Object.entries(theme.bosses).map(([id, b]) => (
          <li key={id}>
            <strong>{b.name}</strong>, {b.title.toLowerCase()}: {b.raidText}
          </li>
        ))}
      </ul>
      <ul>
        {Object.values(theme.loot).map((l) => (
          <li key={l.name}>
            <strong>{l.name}:</strong> {l.text}
          </li>
        ))}
      </ul>
      <h2 className="section-title">Eras</h2>
      <p>Na nova partida você escolhe uma era, das crônicas das guerras do Tibia. Cada uma liga uma regra:</p>
      <ul>
        {CHRONICLES.map((c) => (
          <li key={c.id}>
            <strong>{c.title}</strong> ({c.world}, {c.period}): {c.rule}
          </li>
        ))}
      </ul>
    </>
  );
}
